import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CollateralLoanDetailsComponent } from './loan-gtm-components/collateral-loan-details/collateral-loan-details.component';
import { LoanAcademicDetailsComponent } from './loan-gtm-components/loan-academic-details/loan-academic-details.component';
import { LoanBasicInformationComponent } from './loan-gtm-components/loan-basic-information/loan-basic-information.component';
import { LoanDetailsFormComponent } from './loan-gtm-components/loan-details-form/loan-details-form.component';
import { LoanFinalStepComponent } from './loan-gtm-components/loan-final-step/loan-final-step.component';
import { LoanPersonalDetailsComponent } from './loan-gtm-components/loan-personal-details/loan-personal-details.component';
import { LoanVendorListComponent } from './loan-gtm-components/loan-vendor-list/loan-vendor-list.component';
import { LoanWelcomeComponent } from './loan-gtm-components/loan-welcome/loan-welcome.component';
import { NonCollateralLoanDetailsComponent } from './loan-gtm-components/non-collateral-loan-details/non-collateral-loan-details.component';
import { LoanGtmComponent } from './loan-gtm.component';
import { ThankYouComponent } from './loan-gtm-components/thank-you/thank-you.component';
import { UploadDocumentComponent } from './loan-gtm-components/upload-document/upload-document.component';
import { ApplicationStatusComponent } from './loan-gtm-components/application-status/application-status.component';
import { UniversitySuggestedVendorListComponent } from './loan-gtm-components/university-suggested-vendor-list/university-suggested-vendor-list.component';

const routes: Routes = [{
  path: '',
  component: LoanGtmComponent,
  children:[
    
    {
      path: "",
      component: LoanWelcomeComponent,
    },
    {
      path: "basic-information",
      component: LoanBasicInformationComponent,
      pathMatch: 'full'
    },
    {
      path: "basic-information/:puid",
      component: LoanBasicInformationComponent,
      pathMatch: 'full'
    },
    {
      path: "personal-details",
      component: LoanPersonalDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "personal-details/:puid",
      component: LoanPersonalDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "academic-details",
      component: LoanAcademicDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "academic-details/:puid",
      component: LoanAcademicDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "loan-details",
      component: LoanDetailsFormComponent,
      pathMatch: 'full'
    },
    {
      path: "loan-details/:puid",
      component: LoanDetailsFormComponent,
      pathMatch: 'full'
    },
    {
      path: "non-collateral-type",
      component: NonCollateralLoanDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "non-collateral-type/:puid",
      component: NonCollateralLoanDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "collateral-type",
      component: CollateralLoanDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "collateral-type/:puid",
      component: CollateralLoanDetailsComponent,
      pathMatch: 'full'
    },
    {
      path: "result",
      component: LoanVendorListComponent,
      pathMatch: 'full'
    },
    {
      path: "result/:puid",
      component: LoanVendorListComponent,
      pathMatch: 'full'
    },
    {
      path: "result-page",
      component: LoanFinalStepComponent,
      pathMatch: 'full'
    },
    {
      path: "result-page/:puid",
      component: LoanFinalStepComponent,
      pathMatch: 'full'
    },
    {
      path: "thank-you",
      component: ThankYouComponent,
      pathMatch: 'full'
    },
    {
      path: "thank-you/:puid",
      component: ThankYouComponent,
      pathMatch: 'full'
    },
    {
      path: "upload-documents",
      component: UploadDocumentComponent,
      pathMatch: 'full'
    },
    {
      path: "upload-documents/:puid",
      component: UploadDocumentComponent,
      pathMatch: 'full'
    },
    {
      path: "application-status",
      component: ApplicationStatusComponent,
      pathMatch: 'full'
    },
    {
      path: "application-status/:puid",
      component: ApplicationStatusComponent,
      pathMatch: 'full'
    },
    {
      path: "university-vendors",
      component: UniversitySuggestedVendorListComponent,
      pathMatch: "full"
    },
    {
      path: "university-vendors/:puid",
      component: UniversitySuggestedVendorListComponent,
      pathMatch: "full"
    },
    {
      path: ":puid",
      component: LoanWelcomeComponent,
      pathMatch: 'full'
    }
  ]
},


];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoanGtmRoutingModule { }
